import { render, staticRenderFns } from "./GestionEstudioConflictosS1.vue?vue&type=template&id=ceb3a6bc&"
import script from "./GestionEstudioConflictosS1.vue?vue&type=script&lang=js&"
export * from "./GestionEstudioConflictosS1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports